import React, {PropTypes} from "react";


class InfoTabMain extends React.Component {

  constructor() {
    super();
  }

  render() {
    let attendanceMain = this.props.attendanceMain;
    return (
      <div style={{
        width: '100%',
        borderRadius: '5px',
        textAlign: 'left',
        paddingTop: '0px',
        "fontFamily": '"ProximaNova-Regular", "sans-serif","Arial","Helvetica"'
      }}>
        <div className="col-md-8" style={{paddingBottom: '0px', paddingLeft: '30px'}}>
          <table className="table" cellPadding="0" cellSpacing="0">
            <thead>
            </thead>
            <tbody>
            <tr>
              <td><img src="/public/images/user-name.png" style={{paddingRight: '20px'}}/>
                Date:
              </td>
              <td>{this.props.dates.startDate.toString().substr(0, 11)}
                - {this.props.dates.endDate.toString().substr(0, 11)} </td>
            </tr>
            <tr>
              <td><img src="/public/images/down-arrow.png" style={{paddingRight: '27px'}}/>
                Average In Time
              </td>
              <td>{attendanceMain.avgInTime }</td>
            </tr>
            <tr>
              <td><img src="/public/images/up-arrow.png" style={{paddingRight: '27px'}}/>Average Out Time</td>
              <td>{attendanceMain.avgOutTime }</td>
            </tr>
            <tr>
              <td><img src="/public/images/totalTime.png" style={{paddingRight: '19px', marginLeft: '-3px'}}/>Average/Total
                Working Hours
              </td>
              <td>{attendanceMain.avgWorkHours} </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

InfoTabMain.propTypes = {};

export default InfoTabMain;





/** WEBPACK FOOTER **
 ** ./src/feature/attendance/MyAttendance/InfoTabMain.js
 **/